import { Navigate, Outlet } from "react-router-dom";
import tokenData from "./token_data.ts";
import { useState, useEffect } from 'react';
import ImageLoading from '../components/alert/imageLoading.js';

type ProtectedRoutesProps = {
  children?: React.ReactNode;
};

const ProtectedRoutes = ({ children }: ProtectedRoutesProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const authenticate = async () => {

      const data = await tokenData();

      if (data && data.exp * 1000 > Date.now()) {

        setIsAuthenticated(true);
      } else {

        localStorage.removeItem("token");
        setIsAuthenticated(false);
      }
      setIsLoading(false);
    };

    authenticate();
  }, []);

  if (isLoading) {
    return <ImageLoading />;
  }

  if (!isAuthenticated) {

    return <Navigate to="/" replace />;
  }

  return children ?? <Outlet />;
};

export default ProtectedRoutes;
